import React, {useEffect, useState} from 'react';
import stylesFaq from './Faq.module.css';

function Faq(props) {

    const [state, setState] = useState({});
    const [faq, setFaq] = useState([]);

    useEffect(() => {
        createFaq()
    }, [state])


    function createFaq() {
        let divFaq = [];

        divFaq.push(
            <div className={stylesFaq.marginInitial}>
                <div className={"Container ".concat(stylesFaq.fontStylePage)}>
                    {/* h1 di pagina (WCAG 1.3.1): la pagina non aveva alcun titolo di
                        primo livello. Reso con .sr-only (bootstrap-italia) perche' il
                        layout parte direttamente dal primo blocco di contenuto e un
                        titolo visibile ne altererebbe la resa grafica. */}
                    <h1 className={"sr-only"}>Domande frequenti</h1>
                    <p className={stylesFaq.fontStyleElement}>Le finalità del Registro</p>
                    <p>L'obiettivo del Registro è aiutare chi cerca e chi offre servizi di cura e assistenza, censendo
                        su base volontaria gli assistenti familiari in possesso di requisiti adeguati all'incarico da
                        ricoprire e mettendo a disposizione delle famiglie le informazioni per selezionarli e
                        contattarli.</p>

                    <div className={stylesFaq.marginElement}><p className={stylesFaq.fontStyleElement}>Chi può
                        iscriversi al Registro?</p>
                        <p>Si possono iscrivere sia persone in cerca di occupazione, sia persone che già lavorano. I
                            requisiti per l'iscrizione sono:</p>
                    </div>

                    <ul>
                        <li>avere compiuto 18 anni;</li>
                        <li>se cittadini stranieri, essere in possesso di <strong> regolare permesso di
                            soggiorno </strong> che consenta l'attività lavorativa;
                        </li>
                        <li>se cittadini stranieri, avere una <strong> sufficiente conoscenza della lingua
                            italiana </strong>;
                        </li>
                        <li>se cittadini italiani, avere assolto l'<strong>obbligo scolastico</strong>;</li>
                        <li>non avere conseguito condanne penali passate in giudicato e non avere carichi
                            penali pendenti;
                        </li>
                        <li>essere di <strong> sana e robusta costituzione fisica </strong>, attestata da certificato di idoneità generica all'impiego;
                        </li>
                        <li>essere in possesso di <strong>attestato di frequenza </strong>del corso di
                            formazione per assistenti familiari previsto dall'articolo 10 della LR n. 38/2017;
                            fino a quando non sarà possibile per gli assistenti familiari iscriversi ad uno dei corsi
                            previsti dalla LR n.
                            38/2017 (art. 10), questo requisito potrà essere sostituito dall'attestazione di un altro
                            corso di formazione in materia di
                            assistenza familiare o da esperienza lavorativa documentabile di almeno 12 mesi come
                            Assistente Familiare.
                        </li>
                    </ul>

                    <p>Il venir meno di uno dei requisiti sopra esposti comporta la cancellazione dal Registro.</p>

                    <p>L'iscrizione al Registro su richieta dell'assistente familiare ha durata annuale.</p>

                    <div className={stylesFaq.marginElement}><p className={stylesFaq.fontStyleElement}>Come mantenere
                        l'iscrizione?</p>
                        <p>Ogni anno, l'Assistente Familiare sarà avvisato da un SMS della scadenza della sua
                            iscrizione; basterà collegarsi, anche tramite cellulare, per riconfermare o aggiornare dati
                            e disponibilità.</p>
                    </div>

                    <div className={stylesFaq.marginElement}><p className={stylesFaq.fontStyleElement}>Dove presentare
                        la domanda?</p>
                        <p>La tenuta del Registro è affidata agli sportelli per l'assistenza familiare.</p>
                        <a href={"/doveSiamo"}>Trova lo sportello più vicino</a>
                    </div>
                </div>

            </div>
        );

        setFaq(divFaq)

    }

    return (
        <>{faq}</>
    );
}

export default Faq;
